import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";
import {IUserInfo} from "./model/user/IUserInfo";

class UserDataApiDefinition extends ApiDefinition{
    constructor() {
        super("/users");
    }

    async getDataInfo(username: string): Promise<APIResponse<IUserInfo>> {
        return this.get(`${username}/info`)
    }

    async getCurrentUser(): Promise<APIResponse<UserDTO>> {
        return this.get(`info`)
    }
}

export const UserDataApi = new UserDataApiDefinition();